/* SaintPixel — filtres galerie client-side (chantier 37 Phase D, v1.1).
   Données : data-attributes posés par sections/sp-filtered-gallery.liquid.
   Logique : bitmasks par axe — OR intra-axe, AND inter-axes, compteurs croisés.
   COLOR est mono-sélection (cliquer une autre teinte remplace) ; le rang de la
   couleur dans data-sp-color (dominante d'abord) remonte les dominantes en tête.
   Affichage par lots de 48 ("Voir plus"). État : hash URL #f=axe:val,val;...
   (Markets strippe les query params). */
(function () {
  "use strict";

  var HEX = {
    rouge: "#C0392B", "rouge-orange": "#D35400", orange: "#E67E22",
    "jaune-orange": "#E8A33D", jaune: "#E3C44B", "jaune-vert": "#9CB13E",
    vert: "#4E7A3A", "bleu-vert": "#2E7D6B", bleu: "#2C5F8A",
    "bleu-violet": "#4A4E8F", violet: "#6B4685", "rouge-violet": "#8E3A62",
    noir: "#1A1A1A", gris: "#8A8A85", blanc: "#F2F0E8"
  };
  var AXES = ["color", "palette", "framing", "facture", "orientation"];
  var SINGLE = { color: true };
  var MIN_COUNT = 3;
  var MAX_SHARE = 0.95;
  var PAGE_SIZE = 48;

  var root = document.getElementById("sp-gallery");
  if (!root) return;

  var grid = root.querySelector("[data-sp-grid]");
  var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-sp-tags]"));
  var total = cards.length;

  /* ── Indexation ────────────────────────────────────────────────────── */
  var values = {}, bits = {};
  AXES.forEach(function (ax) { values[ax] = []; bits[ax] = {}; });

  function bitFor(ax, slug) {
    if (!(slug in bits[ax])) { bits[ax][slug] = values[ax].length; values[ax].push(slug); }
    return bits[ax][slug];
  }

  var items = cards.map(function (el) {
    var masks = {}, colorRank = {};
    AXES.forEach(function (ax) {
      var raw = el.getAttribute("data-sp-" + ax) || "";
      var m = 0;
      raw.split(" ").forEach(function (slug, pos) {
        if (!slug) return;
        var b = bitFor(ax, slug);
        m |= 1 << b;
        if (ax === "color") colorRank[b] = pos;
      });
      masks[ax] = m;
    });
    return {
      el: el, masks: masks, colorRank: colorRank,
      ts: parseInt(el.getAttribute("data-sp-ts") || "0", 10)
    };
  });

  /* ── Sélection ─────────────────────────────────────────────────────── */
  var sel = {};
  AXES.forEach(function (ax) { sel[ax] = 0; });
  var visibleLimit = PAGE_SIZE;

  function matches(it, exceptAx) {
    for (var i = 0; i < AXES.length; i++) {
      var ax = AXES[i];
      if (ax === exceptAx || !sel[ax]) continue;
      if (!(it.masks[ax] & sel[ax])) return false;
    }
    return true;
  }

  /* Tri : dominante couleur d'abord quand une couleur est active, puis récent. */
  function sortItems(list) {
    var colorBitIndex = -1;
    if (sel.color) {
      for (var i = 0; i < 31; i++) if (sel.color & (1 << i)) { colorBitIndex = i; break; }
    }
    return list.slice().sort(function (a, b) {
      if (colorBitIndex >= 0) {
        var ra = a.colorRank[colorBitIndex] != null ? a.colorRank[colorBitIndex] : 9;
        var rb = b.colorRank[colorBitIndex] != null ? b.colorRank[colorBitIndex] : 9;
        if (ra !== rb) return ra - rb;
      }
      return b.ts - a.ts;
    });
  }

  /* ── Hash URL ──────────────────────────────────────────────────────── */
  function writeHash() {
    var parts = [];
    AXES.forEach(function (ax) {
      if (!sel[ax]) return;
      var slugs = values[ax].filter(function (s, i) { return sel[ax] & (1 << i); });
      parts.push(ax + ":" + slugs.join(","));
    });
    var h = parts.length ? "#f=" + parts.join(";") : "";
    history.replaceState(null, "", h || location.pathname + location.search);
  }

  function readHash() {
    var m = location.hash.match(/^#f=(.+)$/);
    AXES.forEach(function (ax) { sel[ax] = 0; });
    if (!m) return;
    decodeURIComponent(m[1]).split(";").forEach(function (part) {
      var kv = part.split(":");
      if (kv.length !== 2 || AXES.indexOf(kv[0]) === -1) return;
      kv[1].split(",").forEach(function (slug) {
        if (slug in bits[kv[0]]) sel[kv[0]] |= 1 << bits[kv[0]][slug];
      });
      if (SINGLE[kv[0]] && sel[kv[0]]) sel[kv[0]] &= -sel[kv[0]]; /* garde le bit le plus bas */
    });
  }

  /* ── UI ────────────────────────────────────────────────────────────── */
  var t = JSON.parse(document.getElementById("sp-filters-i18n").textContent);
  var buttons = {};

  function labelFor(ax, slug) { return t[ax + "_" + slug] || slug; }

  function toggle(ax, bit) {
    if (SINGLE[ax]) {
      sel[ax] = (sel[ax] === bit) ? 0 : bit;
    } else {
      sel[ax] ^= bit;
    }
    visibleLimit = PAGE_SIZE;
    writeHash();
    apply(true);
  }

  AXES.forEach(function (ax) {
    var row = root.querySelector('[data-sp-axis="' + ax + '"]');
    if (!row) return;
    buttons[ax] = [];
    var shown = 0;
    values[ax].forEach(function (slug, i) {
      var bit = 1 << i, n = 0;
      items.forEach(function (it) { if (it.masks[ax] & bit) n++; });
      if (n < MIN_COUNT || n > total * MAX_SHARE) return;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "sp-f__btn" + (ax === "color" ? " sp-f__btn--swatch" : "");
      b.setAttribute("aria-pressed", "false");
      var label = labelFor(ax, slug);
      if (ax === "color") {
        b.style.background = HEX[slug] || "#999";
        b.setAttribute("aria-label", label);
        b.title = label;
      } else {
        b.textContent = label;
        var c = document.createElement("span");
        c.className = "sp-f__count";
        b.appendChild(c);
      }
      b.addEventListener("click", function () { toggle(ax, bit); });
      row.appendChild(b);
      buttons[ax].push({ el: b, bit: bit, slug: slug });
      shown++;
    });
    /* Un axe avec moins de 2 valeurs visibles ne filtre rien : on le masque. */
    if (shown < 2) {
      var group = row.closest("[data-sp-group]");
      if (group) group.hidden = true;
      (buttons[ax] || []).forEach(function (entry) { entry.el.remove(); });
      buttons[ax] = [];
    }
  });

  var countEl = root.querySelector("[data-sp-count]");
  var clearEl = root.querySelector("[data-sp-clear]");
  var emptyEl = root.querySelector("[data-sp-empty]");
  var activeEl = root.querySelector("[data-sp-active]");
  var moreEl = root.querySelector("[data-sp-more]");
  var topEl = root.querySelector("[data-sp-top]");
  var sheetToggle = root.querySelector("[data-sp-sheet-toggle]");
  var sheet = root.querySelector("[data-sp-sheet]");
  var backdrop = root.querySelector("[data-sp-backdrop]");
  var applyEl = root.querySelector("[data-sp-apply]");

  clearEl.addEventListener("click", function () {
    AXES.forEach(function (ax) { sel[ax] = 0; });
    visibleLimit = PAGE_SIZE;
    writeHash();
    apply(true);
  });

  moreEl.addEventListener("click", function () {
    visibleLimit += PAGE_SIZE;
    apply(false);
  });

  topEl.addEventListener("click", function () {
    window.scrollTo({ top: root.offsetTop - 80, behavior: "smooth" });
  });
  window.addEventListener("scroll", function () {
    topEl.hidden = window.scrollY < window.innerHeight * 1.5;
  }, { passive: true });

  function setSheet(open) {
    root.classList.toggle("sp-f--open", open);
    sheetToggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (backdrop) backdrop.hidden = !open;
  }

  if (sheetToggle && sheet) {
    sheetToggle.addEventListener("click", function () {
      setSheet(!root.classList.contains("sp-f--open"));
    });
    if (backdrop) backdrop.addEventListener("click", function () { setSheet(false); });
    if (applyEl) applyEl.addEventListener("click", function () { setSheet(false); });
  }

  window.addEventListener("hashchange", function () {
    readHash();
    visibleLimit = PAGE_SIZE;
    apply(true);
  });

  function renderActiveChips() {
    activeEl.textContent = "";
    AXES.forEach(function (ax) {
      if (!sel[ax]) return;
      values[ax].forEach(function (slug, i) {
        var bit = 1 << i;
        if (!(sel[ax] & bit)) return;
        var chip = document.createElement("button");
        chip.type = "button";
        chip.className = "sp-f__chip";
        if (ax === "color") {
          var dot = document.createElement("span");
          dot.className = "sp-f__chip-dot";
          dot.style.background = HEX[slug] || "#999";
          chip.appendChild(dot);
        }
        chip.appendChild(document.createTextNode(labelFor(ax, slug)));
        var x = document.createElement("span");
        x.className = "sp-f__chip-x";
        x.textContent = "×";
        chip.appendChild(x);
        chip.addEventListener("click", function () { toggle(ax, bit); });
        activeEl.appendChild(chip);
      });
    });
  }

  /* ── Rendu ─────────────────────────────────────────────────────────── */
  function render() {
    var matched = sortItems(items.filter(function (it) { return matches(it, null); }));
    var shown = Math.min(matched.length, visibleLimit);

    items.forEach(function (it) { it.el.style.display = "none"; });
    matched.forEach(function (it, idx) {
      grid.appendChild(it.el);
      if (idx < shown) it.el.style.display = "";
    });

    AXES.forEach(function (ax) {
      (buttons[ax] || []).forEach(function (entry) {
        var on = !!(sel[ax] & entry.bit);
        var n = 0;
        items.forEach(function (it) {
          if (matches(it, ax) && (it.masks[ax] & entry.bit)) n++;
        });
        entry.el.setAttribute("aria-pressed", on ? "true" : "false");
        entry.el.classList.toggle("sp-f__btn--on", on);
        entry.el.classList.toggle("sp-f__btn--off", !n && !on);
        entry.el.disabled = !n && !on;
        var c = entry.el.querySelector(".sp-f__count");
        if (c) c.textContent = " " + n;
      });
    });

    renderActiveChips();

    var active = AXES.some(function (ax) { return sel[ax]; });
    countEl.textContent = t.results_count.replace("{shown}", matched.length).replace("{total}", total);
    clearEl.hidden = !active;
    emptyEl.hidden = matched.length > 0;
    grid.style.display = matched.length ? "" : "none";
    moreEl.hidden = matched.length <= visibleLimit;
    if (sheetToggle) {
      var nsel = 0;
      AXES.forEach(function (ax) {
        for (var m = sel[ax]; m; m >>= 1) nsel += m & 1;
      });
      sheetToggle.textContent = t.filter_button + (nsel ? " (" + nsel + ")" : "");
    }
    if (applyEl) applyEl.textContent = t.show_results.replace("{shown}", matched.length);
  }

  function apply(animate) {
    if (animate && document.startViewTransition) {
      document.startViewTransition(render);
    } else {
      render();
    }
  }

  readHash();
  apply(false);
  root.classList.add("sp-f--ready");
})();
